import i18n from 'i18next';
import Backend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';
import HttpApi from "i18next-http-backend";

// Mapping language codes to custom folder names
// const languageMap = {
//   en: "english",
//   es: "spanish",
//   fr: "french",
//   zh: "mandarin",
//   cn: "chinese",
//   pl: "polish",
//   ko: "korean",
//   ja: "japanese",
//   vi: "vietnamese",
//   hi: "hindi",
//   tl: "tagalog",
// };

i18n
  .use(HttpApi)
  .use(LanguageDetector)
  .use(Backend)
  .use(initReactI18next)
  .init({
    debug: !true, //  if set to true then it will print all i18n detail in console
    fallbackLng: 'en',
    // supportedLngs: Object.keys(languageMap), // Use standard language codes
    returnObjects: true,
    fallbackToDefaultNS: true, // Whether to fallback to the default namespace if translation is not found in the specified namespace
    keySeparator: '.', // Separator for nested keys in translation keys
    partialBundledLanguages: false, // Whether to use partial bundled languages
    // backend: {
    //   loadPath: (lng) => {
    //     const folder = languageMap[lng] || "english"; // Default to English if not found
    //     return `/locales/${folder}/${lng}.json`;
    //   },
    // },
    interpolation: {
      escapeValue: false, // React already escapes values
    },
  })

